<div class="parameter-view-header__grid" [style.grid-template-columns]="gridTemplateColumns()">
  <span class="parameter-view-header__title-item">Name</span>
  @if (columnTitles().length) {
    @for (columnTitle of columnTitles(); track columnTitle) {
      <span class="parameter-view-header__title-item">{{ columnTitle }}</span>
    }
  } @else {
    <span class="parameter-view-header__title-item">Value</span>
  }
</div>
